import { Redirect, Route, RouteProps } from 'react-router-dom'
import { SessionService } from '../../services/session/SessionService'

export default function AnonymousRoute({ children, ...rest }: RouteProps) {
	const sessionService = SessionService.getInstance()

	return (
		<Route
			{...rest}
			render={({ location }) =>
				!sessionService.isSignedInUser ? (
					<>{children}</>
				) : (
					<Redirect
						to={{
							pathname: '/_user/_home',
							state: { from: location },
						}}
					></Redirect>
				)
			}
		/>
	)
}
